import React from "react"
import StoreVisitReservation from "../../../../../features/stores/components/StoreVisitReservation"
import { toStoreVisitReservationProps } from "../../../converters/storeVisitReservation"

interface Props {
  content: any
}

const StoreReservationWrapper = ({ content }: Props) => {
  return (
    <StoreVisitReservation
      {...toStoreVisitReservationProps(content.item.storeVisitReservation)}
    />
  )
}

export default StoreReservationWrapper
